<template>
<div class="custom_switch">

<label class="switch">
  <span class="material-symbols-outlined  text-white md-18 on ">{{off_icon}}</span>
  <span class="material-symbols-outlined  text-white md-18 off ">{{on_icon}}</span>   
  <input type="checkbox" class="input" @change="updated" v-model="themodel">
  <span class="slider"></span>
</label>


</div>
</template>

<script>
export default {

  name: 'CustomSwitch',
  props:["initialstate","on_icon","off_icon","on_bg_color","off_bg_color","on_value","off_value"],

  data () {
    return {
    	themodel:false,
    }
  },
  mounted()
  {
  	this.themodel = this.initialstate
  	this.applyCSS()
  },
  methods:{
  	applyCSS() {
		let onbg = "#352f8d"
		let offbg = "#352f8d"
		if(this.on_bg_color)
		{
			onbg = this.on_bg_color
		}
		if(this.off_bg_color)
		{
			offbg =  this.off_bg_color
		}

		let cssRule = `.custom_switch .slider {background-color: ${offbg}}.custom_switch .input:checked + .slider{background-color: ${onbg}}.custom_switch .input:focus + .slider { box-shadow: 0 0 1px ${onbg}}`;
		let style = document.createElement("style");
		style.type = "text/css";
		this.$el.appendChild(style);
		style.innerHTML = cssRule;
    },
  	updated()
  	{
  		let on_value = true
  		let off_value = false
  		if(this.on_value)
  		{
  			on_value = this.on_value
  		}
  		if(this.off_value)
  		{
  			off_value = this.off_value
  		}
  		let emit_obj = off_value
  		if(this.themodel)
  		{
  			emit_obj = on_value
  		}

  		this.$emit("updated",emit_obj)
  	}
  }
}
</script>

<style lang="css">
.custom_switch .switch {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 30px;
  cursor: pointer;
  box-shadow: rgb(93 62 188 / 10%) 0px 6px 24px;
}

.custom_switch .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom_switch .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #352f8d;
  transition: .4s;
  border-radius: 30px;
}

.custom_switch .slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  border-radius: 50%;
  left: 3px;
  bottom: 3px;
  z-index: 2;
  background-color: #f8f8f8;
  transition: .4s;
}


.custom_switch .input:checked + .slider:before {
  transform: translateX(34px);
}
.custom_switch .on{
  position: absolute;
  top: 6px;
  left: 38px;
  z-index: 1;
  width: 22px;
  height: 22px;
}
.custom_switch .off{
  position: absolute;
  top: 6px;
  left: 5px;
  z-index: 1;
  width: 22px;
  height: 22px;
}
</style>